/**
 * Formats a group label with its academic year (e.g. "Basket - Avanzato (2026/2027)").
 *
 * Can be called with:
 * - A group object: formatGroupOptionLabel(group)
 * - Name and year: formatGroupOptionLabel(groupName, academicYear)
 *
 * @param {string|object} groupOrName Group name string or group object
 * @param {number|string} [explicitAcademicYear] Optional academic year
 * @returns {string} Formatted label
 */
export const formatGroupOptionLabel = (groupOrName, explicitAcademicYear) => {
  if (!groupOrName) return '';

  let name = '';
  let academicYear = explicitAcademicYear;

  if (typeof groupOrName === 'object') {
    name = groupOrName.name || '';
    academicYear = explicitAcademicYear !== undefined
      ? explicitAcademicYear
      : (groupOrName.course?.academicYear || groupOrName.academicYear);
  } else {
    name = String(groupOrName);
  }

  if (!academicYear) {
    return name;
  }

  const strYear = String(academicYear).trim();
  if (strYear.includes('/')) {
    return `${name} (${strYear})`;
  }

  const yearNum = parseInt(strYear, 10);
  if (!isNaN(yearNum)) {
    return `${name} (${yearNum}/${yearNum + 1})`;
  }

  return `${name} (${strYear})`;
};
